/**
 * User input validation utilities
 * Refactored from mixins/userInput.js to pure utility functions
 * 
 * Prevent input that could create malformed JSON or allow SQL injection attacks
 */

const REGEX_MATCH_UNPERMITTED_CHARS = /["\\;|]/

/**
 * Check if user input is present and not empty
 * @param {string|null|undefined} userInput - Input to validate
 * @returns {boolean} True if input is present and non-empty
 */
export function inputPresent(userInput) {
    return userInput !== null &&
        userInput !== undefined &&
        userInput.length > 0 &&
        userInput.trim() !== ''
}

/**
 * Check if user input contains unpermitted characters
 * Unpermitted characters: " \ ; |
 * @param {string} userInput - Input to validate
 * @returns {boolean} True if input contains unpermitted characters
 */
export function hasUnpermittedCharacters(userInput) {
    return REGEX_MATCH_UNPERMITTED_CHARS.test(userInput)
}

/**
 * Check if user input matches a regular expression pattern
 * @param {string} regularExpressionPattern - Regex pattern to match against
 * @param {string} userInput - Input to validate
 * @returns {boolean} True if input matches pattern, false if no pattern or no match
 */
export function matchesPattern(regularExpressionPattern, userInput) {
    if (!regularExpressionPattern) {
        return false
    }

    // Check for unicode category pattern matcher (https://www.regular-expressions.info/unicode.html)
    const regEx = regularExpressionPattern.includes("\\p")
        ? new RegExp(regularExpressionPattern, 'u') // Use unicode match flag
        : new RegExp(regularExpressionPattern)
    return regEx.test(userInput)
}
